import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  LineController,
  PointElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  LineController,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const ExamCumulativeChart = () => {
  const years = ['2018','2019','2020','2021','2022','2023','2024'];
  const centreCounts = [284, 585, 457, 885, 923, 1020, 1106];
  const totalCounts = [249966, 595372, 441308, 1260279, 1349706, 1610047, 1901255];

  const data1 = {
    labels: years,
    datasets: [
      {
        type: 'bar',
        label: 'No. of Centres',
        data: centreCounts,
        backgroundColor: '#28a745'
      },
      {
        type: 'line',
        label: 'Centre‑count Trend',
        data: centreCounts,
        borderColor: '#1e88e5',
        borderWidth: 2,
        tension: 0.4,
        pointRadius: 3,
        fill: false
      }
    ]
  };

  const data2 = {
    labels: years,
    datasets: [
      {
        type: 'bar',
        label: 'Total Count',
        data: totalCounts,
        backgroundColor: '#dc3545'
      },
      {
        type: 'line',
        label: 'Total‑count Trend',
        data: totalCounts,
        borderColor: '#1e88e5',
        borderWidth: 2,
        tension: 0.4,
        pointRadius: 3,
        fill: false
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom' },
      tooltip: { mode: 'index', intersect: false }
    },
    scales: {
      y: { beginAtZero: true, ticks: { callback: val => (val >= 1000 ? val.toLocaleString() : val) } }
    }
  };

  return (
    <div>
      <h2 style={{ textAlign: 'center', fontWeight: 'bold',fontSize: "clamp(1.5rem, 5vw, 3.5rem)" }} className='title split-collab text-danger'>Year‑Wise Centres & Total‑Count</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
        <div style={{ flex: 1, minWidth: '320px', height: '400px' }}>
          <Chart type="bar" data={data1} options={options} />
        </div>
        <div style={{ flex: 1, minWidth: '320px', height: '400px' }}>
          <Chart type="bar" data={data2} options={options} />
        </div>
      </div>
      <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '1.1rem' }}>
        TOTAL COUNT (TILL DATE) = <strong>60,06,700 (PAN INDIA)</strong>
      </p>
    </div>
  );
};

export default ExamCumulativeChart;
